module.exports = __webpack_public_path__ + "img/vimeo.ca5cf958.png";